import logo from './logo.svg';
import './App.css';
import Shop from './components/Shop/Shop';
import Navbar from './components/Navbar/Navbar';

function App() {
  return (
    <div>
      <Navbar></Navbar>
      <Shop></Shop>
    </div>
  );
}

export default App;
